module.exports = __webpack_public_path__ + "static/media/lp-icon-next.a734b4c3.svg";